import { CorptaxPreviewUserMenu, ICorptaxBaseUserMenuProps } from '@cscglobal-tbs/user-menu-ui';
import { useIsFeatureEnabled } from '../../../api/features/features';
import { FullUserMenuEnabled } from '../../../utils/FeatureFlags.constants';
import { FullUserMenuContainer } from './FullUserMenuContainer';

// tbd: this should probably be moved to a constants file but we have so many where would it go?
const IDP_CLIENT_ID = 'calculationReview';

export interface IUserMenuContainerProps extends ICorptaxBaseUserMenuProps {
    idpUrl?: string;
    userSub?: string;
    onSignInDifferentUser?: () => void;
}

export const UserMenuContainer = (props: IUserMenuContainerProps) => {
    const { data: fullUserMenuEnabled } = useIsFeatureEnabled({
        featureFlagName: FullUserMenuEnabled,
    });

    if (!fullUserMenuEnabled) {
        return <CorptaxPreviewUserMenu {...props} />;
    } else {
        return <FullUserMenuContainer {...props} loginHintForIdp={`?login_hint=${props.userSub}&clientId=${IDP_CLIENT_ID}`} />;
    }
};
